import React from 'react'
import styles from './CueIcon.scss'
import { Icon } from 'common/Icon'
import cx from 'classnames'
import { Map } from 'immutable'

const typeToI = Map({
  'Left': 'cue-left',
  'Right': 'cue-right',
  'Slight Left': 'cue-slight-left',
  'Slight Right': 'cue-slight-right',
  'Sharp Left': 'cue-sharp-left',
  'Sharp Right': 'cue-sharp-right',
  'Straight': 'cue-straight',
  'Uturn': 'cue-uturn',
  'Summit': 'cue-summit',
  'Valley': 'cue-valley',
  'Water': 'cue-water',
  'Food': 'cue-food',
  'Danger': 'cue-danger',
  'First Aid': 'cue-first-aid',
  'Control': 'cue-control',
  'Climb': 'cue-climb',
  '4th Category': 'cue-4-cat',
  '3rd Category': 'cue-3-cat',
  '2nd Category': 'cue-2-cat',
  '1st Category': 'cue-1-cat',
  'Hors Category': 'cue-hc',
  'Sprint': 'cue-sprint',
  'Generic': 'cue-generic'
})

const cueToI = (type) => typeToI.get(type, 'cue-generic')

export const CueIcon = ({ type, className, ...props }) => (
  <Icon i={cueToI(type)} className={cx(styles.CueIcon, className)} {...props} />
)
